<template>
  <v-card flat :style="`height: ${ windowSize.y }px; position: 'relative'`" class="pa-1 product-view" v-resize="onResizeHandler">
    <div class="text-center" v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card-text class="pa-0">
      <v-form ref="receiveForm" v-on:submit.prevent>
        <v-row>
          <v-col cols="12" class="pb-0 pt-0 font-weight-bold text-uppercase">
            {{ orderModel.number }}
            <template v-if="modeOfView === CONTSTANTS.RECEIVE">({{ $t('message.order.receiving') }})</template>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0 pr-1 pb-0 mt-1">
            <v-text-field outlined dense hide-details v-model="scanProduct" flat autocomplete="off"
              ref="scanProduct" @change="getRespectiveProductOrder" :loading="productLoading"
            :placeholder="$t('message.order.scanProduct')"></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-1 pb-1 font-weight-bold" v-if="productFound">
            <span v-if="!isNewProduct">{{ productInfo.productname || '' }}</span>
            <span v-else class="red--text">{{ productInfo.name || '' }}</span>
          </v-col>
        </v-row>
        <v-row v-if="productFound">
          <v-col cols="8" class="pt-0 pb-0">
            <v-text-field v-if="!locationSelectedAlready" outlined dense hide-details v-model="selectedLocation" flat autocomplete="off"
              :rules="$_requiredValidation" @change="checkIfLocationValid" :loading="loadingLocation"
              ref="scanLocation" :placeholder="$t('message.product.scanLoc')"></v-text-field>
          </v-col>
          <template v-if="productFound && productInfo.isbatch && modeOfView === CONTSTANTS.COLLECT">
            <v-col cols="8" class="pt-0 mt-2 pb-0">
              <v-text-field outlined dense hide-details v-model="selectBatch" flat autocomplete="off"
              :rules="$_requiredValidation" @change="checkIfBatchContainsQty" :placeholder="$t('message.product.batch')" ref="batchRef"
              :loading="loadingBatch"></v-text-field>
            </v-col>
          </template>
        </v-row>
        <v-row v-if="productFound">
          <template v-if="modeOfView === CONTSTANTS.RECEIVE">
            <v-col :cols="modeOfView === CONTSTANTS.RECEIVE ? '9' : '10'" class="pa-1">
              <v-card-text class="pa-1 pl-2">
                <span class="subheading">{{ $t('message.order.availableToPick') }}</span>
                <v-chip-group v-model="receivedObj" active-class="primary text--accent-5" mandatory>
                  <v-chip v-for="(picked, index) in availableItems" :key="index" :disabled="picked.disabled" :value="picked.id">
                    {{ picked.pickedqty }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-col>
          </template>
          <template v-else>
            <v-col cols="10" class="pa-1">
              <v-row>
                <v-col cols="3" class="text-center pa-0" @click="decreaseQty">
                  <v-btn color="info" fab x-small>
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field outlined dense hide-details type="number" class="text-right" v-model="pickQty"
                    autocomplete="off" ref="qtyRef" :rules="$_qtyValidation" :placeholder="$t('message.product.qty')"></v-text-field>
                </v-col>
                <v-col cols="3" class="text-center pa-0" @click="increaseQty">
                  <v-btn color="info" fab x-small>
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </template>
          <v-col :cols="modeOfView === CONTSTANTS.RECEIVE ? '3' : '2'" class="pa-1 mt-2">
            <v-btn color="primary" small :loading="saveLoading" @click="receiveQtyOnOrder" :disabled="!receivedObj && modeOfView === CONTSTANTS.RECEIVE">
              <template v-if="modeOfView === CONTSTANTS.RECEIVE">{{ $t('message.order.receive') }}</template>
              <template v-else>{{ $t('message.order.pick') }}</template>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <!-- LIST OF PRODUCTS -->
    <v-card-text class="highlight pt-0 pb-0 pl-1 mt-2">
      <v-row>
        <v-col cols="4" class="pa-0 pl-3 font-weight-bold">{{ $t('message.dashboard.product') }}:</v-col>
        <v-col cols="2" class="pa-0 pr-2 text-center font-weight-bold">{{ $t('message.ccsheet.unit') }}</v-col>
        <v-col cols="2" class="pa-0 text-right font-weight-bold">{{ $t('message.order.ordered') }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.pickedQty') }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.received') }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <v-row v-for="(product, index) in listOfProducts" :key="index">
        <v-col cols="4" class="pa-0 pl-3 text-truncate" :title="product.productnumber" :class="{ 'pb-1': (index === listOfProducts.length - 1)}">
          {{ product.productnumber }}
          <br />
          <span>{{ product.productname }}</span>
        </v-col>
        <v-col cols="2" class="pa-0 text-center text-truncate" :title="product.unitname">{{ product.unitname }}</v-col>
        <v-col cols="2" class="pa-0 text-right text-truncate">{{ product.qty | absoluteNumber }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right text-truncate">{{ product.pickedqty_ref | absoluteNumber }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right text-truncate">
          {{ product.receivedqty_ref | absoluteNumber }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-btn color="primary" dark absolute bottom left tabindex="-1" @click="$router.push(`/transfer_orders/${orderId}`)">
      <v-icon left>mdi-arrow-left-bold</v-icon>{{ $t('message.login.back') }}
    </v-btn>
    <v-btn color="primary" dark absolute bottom right tabindex="-1" @click="navigateToView">
      <template v-if="modeOfView === CONTSTANTS.RECEIVE">
        {{ $t('message.order.collect') }}
      </template>
      <template v-else>
        {{ $t('message.order.receive') }}
      </template>
    </v-btn>
  </v-card>
</template>
<script>
import CONTSTANTS from '@/assets/json/constants.json'
export default {
  data () {
    return {
      loading: false,
      orderId: 0,
      listOfProducts: [],
      orderModel: {},
      scanProduct: '',
      windowSize: {
        x: 0,
        y: 0
      },
      productFound: false,
      productInfo: {},
      pickQty: '',
      receivedObj: 0,
      listOfLocations: [],
      listOfBatchNumbers: [],
      selectedLocation: '',
      selectedLocationId: 0,
      selectBatch: '',
      saveLoading: false,
      loadingBatch: false,
      productLoading: false,
      loadingLocation: false,
      modeOfView: this.$route.params.mode || 'collect',
      availableItems: [],
      isNewProduct: false,
      locationSelectedAlready: false,
      CONTSTANTS: CONTSTANTS
    }
  },
  mounted () {
    this.loading = true
    this.orderId = this.$route.params.order_id
    this.getOrderProducts()
    this.getOrderInfo()
    this.onResizeHandler()
    this.focusField('scanProduct')
  },
  watch: {
    pickQty (val) {
      let pickedQty = parseFloat(this.$format.replaceCommaWithDot(val || 0))
      let products = this.$format.cloneVariable(this.listOfProducts)
      let getFoundProd = products.find(x => x.productid === this.productInfo.productid)
      if (getFoundProd || this.isNewProduct) {
        var totalQty = 0
        var pickedCount = 0
        // for products that have not been planned
        if (!getFoundProd) {
          getFoundProd = {}
          getFoundProd.qty = val
          getFoundProd.pickedorders = []
        }
        if (getFoundProd.pickedorders) {
          for (let i = 0; i < getFoundProd.pickedorders.length; i++) {
            if (i !== getFoundProd.pickedorders.length) {
              let pickedQty = this.$format.replaceCommaWithDot(getFoundProd.pickedorders[i].pickedqty)
              pickedCount += parseFloat(pickedQty)
            }
          }
        }
        totalQty += parseFloat(pickedCount)
        if (pickedQty) {
          let parentReceivedQty = pickedQty
          totalQty += parentReceivedQty
        }
        let orderedQty = this.$format.replaceCommaWithDot(getFoundProd.qty)
        let getOnStockFromLocation = this.listOfLocations.find(x => x.locationid === this.selectedLocationId)
        if (parseFloat(orderedQty) < totalQty || (getOnStockFromLocation && getOnStockFromLocation.on_stock < totalQty)) {
          totalQty = parseFloat(orderedQty) - parseFloat(pickedCount)
          totalQty = getOnStockFromLocation.on_stock < totalQty ? getOnStockFromLocation.on_stock : totalQty
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
          setTimeout(() => {
            this.pickQty = totalQty
          })
        }
        if (this.productInfo.isbatch) this.checkIfBatchContainsQty()
      }
    }
  },
  methods: {
    getOrderInfo () {
      let model = {
        'filter': `id eq '${this.orderId}'`
      }
      this.$api.execute('post', 'warehouseorders/query', model)
        .then((response) => {
          if (response.data) {
            this.orderModel = response.data[0]
            if (this.modeOfView === CONTSTANTS.RECEIVE) this.getAllLocations()
          }
        })
    },
    getAvailableLocationsHandler (productid) {
      this.loadingLocation = true
      this.$api.execute('get', `/stocks/get_product_by_warehouse?product_id=${productid}&warehouse_id=${this.orderModel.warehouseid}`)
        .then((result) => {
          let model = result.data
          this.listOfLocations = model
          this.loadingLocation = false
        })
    },
    getBatchNumbersByLocation (locationid) {
      this.loadingBatch = true
      this.$api.execute('get', `warehouseorderitems/get_batchnumbers_by_location?product_id=${this.productInfo.productid}&location_id=${locationid}`)
        .then((result) => {
          let model = result.data
          this.listOfBatchNumbers = model
          this.loadingBatch = false
        })
    },
    checkIfBatchContainsQty () {
      if (this.selectBatch) {
        let getObj = this.listOfBatchNumbers.find(x => x.batchnumber === this.selectBatch)
        let pickedQty = parseFloat(this.$format.replaceCommaWithDot(this.pickQty || 0))
        if (getObj) {
          if (getObj.onstock < pickedQty) {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
            setTimeout(() => {
              this.pickQty = ''
            })
          }
        } else {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.notValidBatch') })
          setTimeout(() => {
            this.selectBatch = ''
          })
        }
      }
    },
    getAllLocations () {
      let query = {
        select: ['id', 'name', 'warehouseid', 'isdefault'],
        filter: `isactive eq 1 and warehouseid eq ${this.orderModel.destinationwarehouseid || 0}`,
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      this.$api.execute('post', 'warehouselocations/query', query)
        .then(response => {
          this.listOfLocations = response.data
        })
    },
    getOrderProducts () {
      this.loading = true
      this.$api.execute('get', `/warehouseorderitems/get_by_order_pwa/${this.orderId}`)
        .then((response) => {
          this.listOfProducts = []
          if (response.data) {
            let products = response.data
            if (products) {
              if (products) {
                for (let i = 0; i < products.length; i++) {
                  let receivedCount = 0
                  for (let j = 0; j < products[i].receivedorders.length; j++) {
                    let receivedQty = this.$format.replaceCommaWithDot(products[i].receivedorders[j].receivedqty)
                    receivedCount += parseFloat(receivedQty)
                  }
                  products[i].receivedqty = ''
                  products[i].receivedqty_ref = receivedCount
                  let pickedCount = 0
                  for (let j = 0; j < products[i].pickedorders.length; j++) {
                    let pickedQty = this.$format.replaceCommaWithDot(products[i].pickedorders[j].pickedqty)
                    pickedCount += parseFloat(pickedQty)
                  }
                  products[i].pickedqty = ''
                  products[i].pickedqty_ref = pickedCount
                }
              }
              this.listOfProducts = products
            }
            this.restorePreset()
            this.productInfo = {}
            this.scanProduct = ''
            this.productFound = false
            this.focusField('scanProduct')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getRespectiveProductOrder () {
      this.selectedLocation = ''
      this.receivedObj = null
      if (this.scanProduct) {
        this.productLoading = true
        let list = this.$format.cloneVariable(this.listOfProducts)
        this.selectedLocationId = 0
        this.locationSelectedAlready = false
        this.isNewProduct = false
        this.productInfo = {}
        if (list) {
          const scanedLower = this.scanProduct.toLowerCase()
          let getProduct = list.find(x => (x.barcode || '').toLowerCase() === scanedLower || (x.productnumber || '').toLowerCase() === scanedLower || (x.productnumberbarcode || '').toLowerCase() === scanedLower)
          if (getProduct) {
            this.productFound = true
            this.productInfo = getProduct
            let receivedIndexes = []
            let locationSelected = 0
            getProduct.pickedorders.map(x => {
              if (!locationSelected) locationSelected = x.locationid || 0
              getProduct.receivedorders.map((y, index) => {
                if (y.receivedqty === x.pickedqty) {
                  receivedIndexes.push(index)
                }
              })
            })
            this.availableItems = getProduct.pickedorders.filter((x, index) => !receivedIndexes.includes(index)).map((y, i) => {
              if (i > 0) y.disabled = true
              return y
            })
            this.focusField('scanLocation')
            if (this.modeOfView === CONTSTANTS.COLLECT) {
              this.getAvailableLocationsHandler(getProduct.productid)
              setTimeout(() => {
                if (locationSelected) {
                  this.locationSelectedAlready = true
                  this.selectedLocationId = locationSelected
                  this.getBatchNumbersByLocation(this.selectedLocationId)
                } else this.locationSelectedAlready = false
              })
            }
          } else {
            this.selectedLocationId = 0
            const product = await this.getProductByNumber()
            if (product.data && product.data[0]) {
              this.productFound = true
              product.data[0].isbatch = product.data[0].batchrequired
              product.data[0].productid = product.data[0].id
              this.productInfo = product.data[0]
              this.isNewProduct = true
              this.getAvailableLocationsHandler(product.data[0].id)
            } else {
              this.productInfo = {}
              this.productFound = false
              this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.product.noProductFound') })
              this.focusField('scanProduct')
              this.scanProduct = ''
            }
          }
          this.restorePreset()
          this.productLoading = false
        }
      }
    },
    getProductByNumber () {
      let model = {
        'filter': `number eq '${this.scanProduct}' OR barcode eq '${this.scanProduct}'`,
        'additionalfilters': [`isactive eq 1 AND ispackage ne 1`],
        'skip': 0,
        'limit': 50,
        'order_by': {
          'field': 'number',
          'asc_or_desc': 'asc'
        }
      }
      return this.$api.execute('post', 'products/query', model)
    },
    receiveQtyOnOrder () {
      let pickedQty = this.$format.replaceCommaWithDot(this.pickQty || 0)
      let received = this.$format.cloneVariable(this.receivedObj)
      if (!this.productInfo.pickedorders) this.productInfo.pickedorders = []
      // eslint-disable-next-line eqeqeq
      let getSelectedQty = this.productInfo.pickedorders.find(x => x.id == received)
      let receivedQty = getSelectedQty ? this.$format.replaceCommaWithDot(getSelectedQty.pickedqty || 0) : 0
      let qtyValue = this.modeOfView === CONTSTANTS.RECEIVE ? receivedQty : pickedQty
      if (this.$refs.receiveForm.validate() && qtyValue > 0) {
        let locationid = this.selectedLocationId || 0
        let products = this.$format.cloneVariable(this.listOfProducts)
        this.saveLoading = true
        let model = products.find(x => x.productid === this.productInfo.productid)
        let listOfItems = []
        if (model) {
          listOfItems = products.filter(x => x.id !== model.id)
          if (locationid) {
            if (!model.receivedorders) model.receivedorders = []
            if (receivedQty) {
              model.receivedorders.push({ batchnumber: this.selectBatch || '', receivedqty: receivedQty, locationid: locationid })
            }
            if (!model.pickedorders) model.pickedorders = []
            if (pickedQty) {
              model.pickedorders.push({ batchnumber: this.selectBatch || '', pickedqty: pickedQty, locationid: locationid })
            }
            model.pickedqty = pickedQty
          }
        } else {
          model = {}
          model.locationid = locationid
          model.qty = pickedQty
          model.productid = this.productInfo.productid
          if (!model.pickedorders) model.pickedorders = []
          if (!model.receivedorders) model.receivedorders = []
          if (pickedQty) {
            model.pickedorders.push({ batchnumber: this.selectBatch || '', pickedqty: pickedQty, locationid: locationid })
          }
          model.pickedqty = pickedQty
        }
        listOfItems.push(model)
        if (locationid) {
          let modelObj = { 'items': listOfItems }
          this.$api.execute('post', `/warehouseorderitems/bulk_save_pwa/${this.orderId}/${this.isNewProduct}`, modelObj)
            .then((response) => {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
              if (response.data && response.data.status === 'received') this.$router.push('/transfer_orders')
              else this.getOrderProducts()
            })
            .finally(() => {
              this.saveLoading = false
            })
        } else {
          this.saveLoading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        }
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    onResizeHandler () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight - 40 }
    },
    decreaseQty () {
      if (this.pickQty > 0) this.pickQty--
    },
    increaseQty () {
      if (this.pickQty < 0) this.pickQty = ''
      this.pickQty++
    },
    checkIfLocationValid () {
      this.loadingLocation = true
      let locations = this.listOfLocations
      let field = this.modeOfView === CONTSTANTS.RECEIVE ? 'name' : 'location_name'
      let getOnStockValue = locations.find(x => x[field] === this.selectedLocation)
      if (getOnStockValue) {
        let dataField = this.modeOfView === CONTSTANTS.RECEIVE ? 'id' : 'locationid'
        this.selectedLocationId = getOnStockValue[dataField]
        if (this.productInfo.isbatch) this.getBatchNumbersByLocation(this.selectedLocationId)
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.noLocFound') })
        setTimeout(() => {
          this.selectedLocation = ''
          this.selectedLocationId = 0
          this.focusField('scanLocation')
        })
      }
      this.loadingLocation = false
    },
    focusField (value) {
      requestAnimationFrame(() => {
        if (this.$refs[value]) {
          this.$refs[value].focus()
        }
      })
    },
    navigateToView () {
      const view = this.modeOfView === CONTSTANTS.RECEIVE ? CONTSTANTS.COLLECT : CONTSTANTS.RECEIVE
      this.$router.push(`/transfer_orders/${this.orderId}/transfer/${view}`)
    },
    restorePreset () {
      this.selectBatch = ''
      this.pickQty = ''
      this.selectedLocation = ''
      this.selectedLocationId = 0
    }
  }
}
</script>
